<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()">
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label for="producto">* {{ 'SEGMENTOSPRODUCTOS.LBL_PRODUCTOS' | translate}}</label>
                <p-dropdown disableTab  id="producto" [options]="productos" formControlName="idProducto"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submitted && f.idProducto.errors">
                  <i class="fa fa-close"></i>{{ 'SEGMENTOSPRODUCTOS.MSG_PROREQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6 text-md-right text-lg-right text-center">
              <button class="p-button-datatables" pButton icon="fa fa-plus" label="{{ 'LBL_AGREGAR' | translate}}" type="submit"></button>
            </div>
          </div>
        </form>
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="carSegmentoProducto" #dt
                 [value]="segProductos" selectionMode="single" dataKey="idConstante"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                  class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.producto}}</td>
              <td>{{row.tipoProductoBancario}}</td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-danger btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_DESHABILITAR' | translate}}" pButton
                          (click)="disable(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>


<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
